export default __webpack_public_path__ + "static/media/include_12@3x.0f526165.jpg";